import {
  //badgeRecipe,
  buttonRecipe as baseButtonRecipe,
  skeletonRecipe as baseSkeletonRecipe,
  //skipNavLinkRecipe,
  spinnerRecipe as baseSpinnerRecipe,
  checkmarkRecipe,
  //codeRecipe,
  //colorSwatchRecipe,
  containerRecipe,
  headingRecipe,
  iconRecipe,
  //inputAddonRecipe,
  // inputRecipe,
  //kbdRecipe,
  linkRecipe,
  markRecipe,
  radiomarkRecipe,
  separatorRecipe,
  //textareaRecipe,
} from '@chakra-ui/react/theme';

import { chipRecipe } from './chip';
import { inputRecipe } from './input';
import { panelRecipe } from './panel';
import { inputAddonRecipe } from './input-addon';
import { textareaRecipe } from './textarea';

// `md` is the default size, so this is what you get without asking — and at 40px it
// lands 4px under the 44px tap minimum on touch. `lg` is already 44px; the denser
// sizes (2xs/xs/sm) are left alone on purpose: growing them would wreck comment
// density, so they need an expanded hit area instead, which has to be done per-case
// where we can see what a widened target would overlap.
//
// `any-pointer`, not `pointer`: an iPad on a Magic Keyboard reports the trackpad as
// its primary pointer while the touchscreen is still there. Desktop mice never match,
// so this is inert on desktop.
//
// Both min-* are required. IconButton has no recipe of its own in Chakra v3 — it is
// literally <Button px="0" py="0"> — so min-height alone would stretch every square
// icon button into an ellipse.
const coarseTapTarget = {
  '@media (any-pointer: coarse)': { minHeight: '44px', minWidth: '44px' },
};

const buttonRecipe = {
  ...baseButtonRecipe,
  base: { ...baseButtonRecipe.base, fontWeight: '600', colorPalette: 'purple' },
  variants: {
    ...baseButtonRecipe.variants,
    size: {
      ...baseButtonRecipe.variants?.size,
      md: { ...baseButtonRecipe.variants?.size?.md, fontSize: 'md', ...coarseTapTarget },
    },
  },
};

const spinnerRecipe = {
  ...baseSpinnerRecipe,
  base: { ...baseSpinnerRecipe.base, color: 'purple.400' },
};

// Скелетон по умолчанию заливается bg.emphasized (brand.600) — это СВЕТЛЕЕ карточки, которую
// он подменяет (bg.card = brand.700). Из-за этого пустая лента выглядела ярче заполненной.
// Приглушаем: своя заливка чуть выше фона страницы и более медленный, менее контрастный пульс.
const skeletonRecipe = {
  ...baseSkeletonRecipe,
  variants: {
    ...baseSkeletonRecipe.variants,
    variant: {
      ...baseSkeletonRecipe.variants?.variant,
      pulse: {
        ...baseSkeletonRecipe.variants?.variant?.pulse,
        background: 'bg.skeleton',
        // 1.2s дёргает глаз на пустом экране; 2s читается как «идёт загрузка», а не как мигание.
        animationDuration: 'var(--duration, 2s)',
      },
      shine: {
        ...baseSkeletonRecipe.variants?.variant?.shine,
        '--start-color': 'colors.bg.skeleton',
        '--end-color': 'colors.bg.muted',
      },
    },
  },
};

// Линия в один пиксель разъехалась на шесть цветов: whiteAlpha.200, bg.muted, purple.300,
// border.subtle, border и один rgba числом. Разницу между ними не видит никто, но сменить их
// разом было нельзя — цвет проставлял вызывающий. Ставим здесь тот, что и так преобладал
// (border это whiteAlpha.200, 11 мест из 24), и вызывающему больше ничего передавать не нужно.
const separatorRecipeWithBorder = {
  ...separatorRecipe,
  base: { ...separatorRecipe.base, borderColor: 'border' },
};

export const recipes = {
  //badge: badgeRecipe,
  button: buttonRecipe,
  //code: codeRecipe,
  chip: chipRecipe,
  container: containerRecipe,
  heading: headingRecipe,
  input: inputRecipe,
  inputAddon: inputAddonRecipe,
  //kbd: kbdRecipe,
  link: linkRecipe,
  mark: markRecipe,
  panel: panelRecipe,
  separator: separatorRecipeWithBorder,
  skeleton: skeletonRecipe,
  //skipNavLink: skipNavLinkRecipe,
  spinner: spinnerRecipe,
  textarea: textareaRecipe,
  icon: iconRecipe,
  checkmark: checkmarkRecipe,
  radiomark: radiomarkRecipe,
  //colorSwatch: colorSwatchRecipe,
};
